import { render, staticRenderFns } from "./CardHorizontal.vue?vue&type=template&id=69cb8d2f&scoped=true&name=card-horizontal&"
import script from "./CardHorizontal.vue?vue&type=script&lang=js&"
export * from "./CardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./CardHorizontal.vue?vue&type=style&index=0&id=69cb8d2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cb8d2f",
  null
  
)

export default component.exports